import { Formik } from "formik";
import { Fragment } from "react";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { TableCell } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import VerifiedIcon from "@mui/icons-material/Verified";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useAlert, useAxios } from "../../hooks";
import DependentPopup from "./Dependent";
import pages from "../../constants/pages";
import { TextField } from "../../components";
import CustomField from "./CustomField";
import { setDependent } from "../../redux/slices/memberSlice";
import Form from "./form";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";

const OuterBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 75vh;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 17px;
  box-sizing: border-box;
  background: #ffffff;
`;

const OuterPaper = styled(Box)`
  width: 100%;
  border-radius: 15px;
  min-height: 50vh;
  background: rgba(255, 255, 255, 0.5);
  align-content: center;
`;

const TableCells = styled(TableCell)`
  // display: flex;
`;

const EventBox = styled(Grid)`
  background-image: url(${(props) => props.backgroundImage});
  background-size: 100% 100%;
  position: relative;
  background-repeat: no-repeat;
  margin: 0px !important;
  width: 100%;
  height: 25vh !important;
  border-top-lefimport pages from './../../constants/pages';
t-radius: 12.5px;
  border-top-right-radius: 12.5px;
`;

export default function InviteUser() {
  const axios = useAxios();
  const navigate = useNavigate();

  const location = useLocation();

  const { visitorData } = useSelector((state) => state.memberDetails);

  const queryParams = new URLSearchParams(location.search);

  const type = queryParams.get("type");

  const entityID = queryParams.get("entity_id");
  const visitorID = queryParams.get("visitor_id");
  const bookingID = queryParams.get("booking_id");
  const userTypeId = queryParams.get("user_type_id");

  const [userData, setUserData] = useState([]);
  const [badgeOptions, setBadgeOptions] = useState([]);
  const [dependentList, setDependentList] = useState([]);
  const [dependentPopUp, setDependentPopUp] = useState(false);
  const [sendInviteButton, setSendInviteButton] = useState(false);
  const [visitorVaild, setVisitorVaild] = useState([]);
  const [formData, setFormData] = useState({
    visitors: [
      {
        name: "",
        email_id: "",
        phone_number: "",
        badge: "",
        is_verified: false,
        edit: false,
        guestType: undefined,
      },
    ],
  });
  const [customFields, setCustomFields] = useState([]);

  useEffect(() => {
    console.log("oiiip");
    axios({
      url:
        "event/visitor/get-dependent-list?phone_number=" +
        visitorData.phoneNumber,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setDependentList(response.data || []);
      }
    });
    if (userTypeId == 5) {
      let url = "admin/profile/get-visitor-booking-status";

      let method = "POST";

      let data = {
        visitor_id: visitorID,
        entity_id: entityID,
        user_type_id: userTypeId,
        booking_id: bookingID,
        face_data: getVisitorFaceData(visitorID),
      };

      axios({
        url: url,
        disableRedirect: true,
        method: method,
        data: data,
      }).then((response) => {
        if (response.status) {
          let data = Array(parseInt(response?.data[0]?.guests_count))
            .fill(true)
            .map((item, index) => {
              return {
                name:
                  index == 0
                    ? visitorData?.firstName + visitorData?.lastName
                    : "",
                email_id: index == 0 ? visitorData?.emailID : "",
                phone_number: index == 0 ? visitorData?.phoneNumber : "",
                badge_id: "",
                is_verified: visitorData?.isVerified || false,
                edit: index == 0 ? true : false,
                guestType: undefined,
                isContactInfoRequired: true,
              };
            });

          let array = Array(parseInt(response?.data[0]?.guests_count)).fill(
            true
          );
          array[0] = false;
          setVisitorVaild(array);

          setFormData({ visitors: data });
        }
      });
    } else if (userTypeId == 2) {
      let url = "admin/profile/get-visitor-booking-status";

      let method = "POST";

      let data = {
        visitor_id: visitorID,
        entity_id: entityID,
        user_type_id: userTypeId,
        booking_id: bookingID,
        face_data: getVisitorFaceData(visitorID),
      };

      axios({
        url: url,
        disableRedirect: true,
        method: method,
        data: data,
      }).then((response) => {
        if (response.status) {
          axios({
            url:
              "admin/custom-fields/get-appointment-fields?business_id=" +
              response.data[0]?.business_id,
            disableError: true,
            disableRedirect: true,
          }).then((response) => {
            if (response.status) {
              setCustomFields(response.data);
            }
          });

          setUserData(response.data);

          let dataLength = response.data[0]?.total_bookings;

          let data = Array(dataLength)
            .fill(true)
            .map((item, index) => {
              console.log(response.data[index], "response.data[index]");

              return {
                name:
                  response.data[index]?.visitor_info.first_name +
                    response.data[index]?.visitor_info.last_name || "",
                email_id: response.data[index]?.visitor_info.email_id || "",
                phone_number:
                  response.data[index]?.visitor_info.phone_number || "",
                badge_id: "",
                is_verified:
                  response.data[index]?.visitor_info?.is_verified || false,
                isContactInfoRequired:
                  response.data[index]?.journey_status
                    ?.is_contact_info_required || true,
                edit: response.data[index]?.visitor_info?.first_name
                  ? true
                  : false,
                guestType:
                  response.data[index]?.visitor_info?.phone_number ===
                  visitorData?.phoneNumber
                    ? 1
                    : 0,
                ...(response.data[index]?.visitor_info?.phone_number ===
                  visitorData?.phoneNumber && {
                  dependent: response.data[index]?.visitor_id,
                }),
              };
            });
          let array = Array(dataLength).fill(true);
          array[0] = false;
          console.log(data, "data");

          console.log(array, "array");

          setVisitorVaild(array);

          setFormData({ visitors: data });
        }
      });
    } else {
      axios({
        url: `event/booking/get-visitor-badges?visitor_id=${visitorID}&event_id=${entityID}`,
        method: "GET",
        disableRedirect: true,
      })
        .then((response) => {
          if (response.status) {
            setBadgeOptions(response.data);
          }
        })
        .catch((error) => {
          console.error("Error in fetching events list", error);
        });

      axios({
        url: "admin/custom-fields/get-event-fields?event_id=" + entityID,
        disableError: true,
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setCustomFields(response.data);
        }
      });

      let url = "admin/profile/get-visitor-booking-status";

      let method = "POST";

      let data = {
        visitor_id: visitorID,
        entity_id: entityID,
        user_type_id: userTypeId,
        booking_id: bookingID,
        face_data: getVisitorFaceData(visitorID),
      };

      axios({
        url: url,
        disableRedirect: true,
        method: method,
        data: data,
      }).then((response) => {
        console.log("cdscs");

        if (response.status) {
          setUserData(response.data);
          let dataLength = response.data[0]?.total_number_bookings;

          let data = Array(dataLength)
            .fill(true)
            .map((item, index) => {
              return {
                name:
                  response.data[index]?.visitor_info.first_name +
                    response.data[index]?.visitor_info.last_name || "",
                email_id: response.data[index]?.visitor_info.email_id || "",
                phone_number:
                  response.data[index]?.visitor_info.phone_number || "",
                badge_id: response.data[index]?.badge_id || "",
                is_verified:
                  response.data[index]?.visitor_info?.is_verified || false,

                edit: response.data[index]?.visitor_info?.first_name
                  ? true
                  : false,
                isContactInfoRequired:
                  response.data[index]?.journey_status
                    ?.is_contact_info_required || true,
                guestType:
                  response.data[index]?.visitor_info?.phone_number ===
                  visitorData?.phoneNumber
                    ? 1
                    : 0,
                ...(response.data[index]?.visitor_info?.phone_number ===
                  visitorData?.phoneNumber && {
                  dependent: response.data[index]?.visitor_id,
                }),
              };
            });
          let array = Array(dataLength).fill(true);
          array[0] = false;
          setVisitorVaild(array);
          console.log(data, "data");

          setFormData({ visitors: data });
        }
      });
    }
  }, [axios, entityID]);

  function handleUpdateBadge(ID) {
    let badgeDetails = badgeOptions.filter((item) => item.badge_id === ID);

    axios({
      url: `/event/booking/update-visitor-badge`,
      method: "POST",
      data: {
        booking_id: userData[0].booking_id,
        badge_id: badgeDetails[0].badge_id,
        amount: badgeDetails[0].amount,
      },
    }).then((response) => {
      if (response.status) {
      }
    });
  }

  const generateFieldSchema = (field) => {
    let schema;

    switch (field.value_type) {
      case "string":
        schema = Yup.string();
        if (field.regex) {
          schema = schema.matches(
            new RegExp(field.regex),
            field.error_message || "Invalid format"
          );
        }
        break;

      case "boolean":
        schema = Yup.boolean();
        break;

      case "list":
        schema = Yup.array();
        break;

      default:
        schema = Yup.mixed(); // fallback
    }

    if (field.mandatory) {
      schema = schema.required(
        field.error_message || `${field.label} is required`
      );
    }

    return schema;
  };

  const dynamicVisitorSchemaShape = {};

  customFields.forEach((field) => {
    dynamicVisitorSchemaShape[field.name] = generateFieldSchema(field);
  });

  const validationSchema = Yup.object({
    visitors: Yup.array().of(
      Yup.object({
        name: Yup.string().required("Name is required"),
        email_id: Yup.string()
          // .email("Invalid email")
          .required("Email is required"),
        phone_number: Yup.string()
          .matches(
            /^[0-9]{10,12}$/, // This regex checks for exactly 10 digits
            "Phone number must be exactly 10 digits"
          )
          .required("Phone number is required"),
        ...(type == null && {
          badge_id: Yup.string().required("Badge is required"),
        }),
        ...dynamicVisitorSchemaShape,
      })
    ),
  });

  return (
    <OuterBox>
      <Formik
        initialValues={formData}
        // validationSchema={validationSchema}
        validateOnMount
        enableReinitialize
        onSubmit={(formData) => {
          console.log(formData, "formData");

          if (userTypeId == 1) {
            const visitor = formData.visitors
              .map((item, index) => {
                const name = item.name.split(" ");
                return (
                  index !== 0 && {
                    // name: item.name,
                    first_name: name[0] || "",
                    last_name: name.slice(1).join(" ") || "",
                    phone_number:
                      item.phone_number.length == 10
                        ? "91" + item.phone_number
                        : item.phone_number.length > 10
                        ? item.phone_number.substring(2)
                        : item.phone_number,
                    email_id: item.email_id,
                    is_dependent: item.guestType == 0 ? false : true,
                    badge_id: item.badge_id,
                    ...(Boolean(
                      formData?.customField?.length != 0 &&
                        formData?.customField
                    ) && {
                      ...formData?.customField[index],
                    }),
                  }
                );
              })
              .filter((item) => item && item);

            axios({
              url: "event/booking/book-visitor-event",
              method: "POST",
              data: {
                visitors: visitor,
                event_id: userData[0].event_id,
                total_price: userData[0].total_amount,
                reference_visitor_id: userData[0].visitor_info?._id,
                total_bookings: userData[0]?.total_number_bookings,
                reference_id: userData[0].booking_reference_id,
                transaction_id: userData[0].transaction_id,
                order_id: userData[0].order_id,
              },
            }).then((response) => {
              if (response.status) {
                let url = "admin/profile/get-visitor-booking-status";

                let method = "POST";

                let data = {
                  visitor_id: visitorID,
                  entity_id: entityID,
                  user_type_id: userTypeId,
                  booking_id: bookingID,
                  face_data: getVisitorFaceData(visitorID),
                };

                axios({
                  url: url,
                  disableRedirect: true,
                  method: method,
                  data: data,
                }).then((response) => {
                  if (response.status) {
                    navigate(
                      `${pages.EventSummary?.route}?visitor_id=${visitorID}&booking_id=${bookingID}&entity_id=${entityID}&user_type_id=${userTypeId}`,
                      {
                        state: {
                          userData: response.data,
                        },
                      }
                    );
                  }
                });
              }
            });
          } else if (userTypeId == 5) {
            const guestList = formData.visitors
              .map((item, index) => {
                const name = item.name.split(" ");
                return (
                  index !== 0 && {
                    name: item.name,
                    first_name: name[0] || "",
                    last_name: name.slice(1).join(" ") || "",
                    phone_number:
                      item.phone_number.length == 10
                        ? "91" + item.phone_number
                        : item.phone_number.length > 10
                        ? item.phone_number.substring(2)
                        : item.phone_number,
                    email_id: item.email_id,
                    is_dependent: item.guestType == 0 ? false : true,
                  }
                );
              })
              .filter((item) => item && item);

            axios({
              url: "hotel/booking/guest/add",
              method: "POST",
              data: {
                booking_ref_id: bookingID,
                hotel_id: entityID,
                guests: guestList,
              },
              disableError: true,
              disableRedirect: true,
            }).then((response) => {
              if (response.status) {
                navigate(
                  `${pages.HotelSummary.path}?visitor_id=${visitorID}&booking_id=${bookingID}&entity_id=${entityID}&user_type_id=${userTypeId}`,
                  {
                    state: { guestData: response.data },
                  }
                );
              }
            });
          } else if (userTypeId == 2) {
            const guestList = formData.visitors
              .map((item, index) => {
                const name = item.name.split(" ");
                return (
                  index !== 0 && {
                    // name: item.name,
                    first_name: name[0] || "",
                    last_name: name.slice(1).join(" ") || "",
                    mobile:
                      item.phone_number.length == 10
                        ? "91" + item.phone_number
                        : item.phone_number.length > 10
                        ? item.phone_number.substring(2)
                        : item.phone_number,
                    email_id: item.email_id,
                    is_dependent: item.guestType == 0 ? false : true,
                    appointment_date: 1743445800,
                    slot_id: userData[0]?.slot_id,
                    total_bookings: userData[0].total_bookings,
                    officer_id: userData[0].officer_id,
                    ...(Boolean(
                      formData?.customField?.length != 0 &&
                        formData?.customField
                    ) && {
                      ...formData?.customField[index],
                    }),
                  }
                );
              })
              .filter((item) => item && item);

            if (guestList.length != 0) {
              axios({
                url: "appointment/appointment/add-appointment-guest",
                method: "POST",
                data: {
                  reference_visitor_id: userData[0].visitor_id,
                  reference_appointment_id: userData[0].appointment_id,
                  visitors: guestList,
                },
              }).then((response) => {
                if (response.status) {
                  navigate(
                    `${pages.AppointmentSummary?.route}?visitor_id=${visitorID}&booking_id=${bookingID}&entity_id=${entityID}&user_type_id=${userTypeId}`
                  );
                }
              });
            } else {
              navigate(
                `${pages.AppointmentSummary?.route}?visitor_id=${visitorID}&booking_id=${bookingID}&entity_id=${entityID}&user_type_id=${userTypeId}`
              );
            }
          }
        }}
      >
        {(formikProps) => {
          return (
            <Form
              formikProps={formikProps}
              sendInviteButton={sendInviteButton}
              setSendInviteButton={setSendInviteButton}
            />
          );
        }}
      </Formik>

      <DependentPopup
        setDependentList={setDependentList}
        dependentPopUp={dependentPopUp}
        setDependentPopUp={setDependentPopUp}
      />
    </OuterBox>
  );
}
